export default function StyleProvider( { children } ) {
	return children;
}
